
import { useState } from 'react';
import {
  Paper,
  Typography,
  TextField,
  Button,
  Box,
} from '@mui/material';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
const ServiceManager = () => {
  const [service, setService] = useState({
    title: '',
    description: '',
    icon: ''
  });
  const [snackOpen, setSnackOpen] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setService((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const token = localStorage.getItem("token");

    axios({
      method: "POST",
      url: `${process.env.REACT_APP_MY_API}/api/services`,
      data: service,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((res) => {
        console.log("Service added:", res.data);

        // 1. Clear form
        setService({
          title: '',
          description: '',
          icon: ''
        });

        setSnackOpen(true);
      })
      .catch((err) => {
        console.error("Error adding service:", err);
        alert("Failed to add service.");
      });
  };


  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 500, mx: 'auto' }}>
      <Typography variant="h5" gutterBottom>
        Add New Service
      </Typography>

      <Box component="form" noValidate autoComplete="off" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Service Title"
          name="title"
          value={service.title}
          onChange={handleChange}
          fullWidth
          required
        />
        <TextField
          label="Description"
          name="description"
          value={service.description}
          onChange={handleChange}
          fullWidth
          multiline
          rows={3}
        />
        <TextField
          label="Icon (emoji or URL)"
          name="icon"
          value={service.icon}
          onChange={handleChange}
          fullWidth
        />

        <Button variant="contained" onClick={handleSubmit}>
          Add Service
        </Button>
      </Box>
      <Snackbar
        open={snackOpen}
        color='primary'
        autoHideDuration={3000}
        onClose={() => setSnackOpen(false)}
        message="Service added successfully!"
      />
    </Paper>
  );
};



export default ServiceManager;
